export default "__VITE_ASSET__DUdrp_fC__"